import React, { useState, memo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useHistory } from 'react-router-dom';
import { IconButton, Menu } from '@material-ui/core';
import { MoreVert as Options } from '@material-ui/icons';
import ThemedMenuItem from 'common/ThemedMenuItem';
import useOrders from '../useOrders';
import './OrderListingMenu.scss';
const OrderListingMenu = ({ order }) => {
    const history = useHistory();
    const { t } = useTranslation('common');
    const handlers = useOrders();
    const [anchorEl, setAnchorEl] = useState();
    const [contextMenuOrder, setContextMenuOrder] = useState();
    const handleMenuOpen = useCallback((o) => (e) => {
        e.stopPropagation();
        setAnchorEl(e.currentTarget);
        setContextMenuOrder(o);
    }, []);
    const handleMenuClose = useCallback((e) => {
        e.stopPropagation();
        setAnchorEl(undefined);
        setTimeout(() => {
            setContextMenuOrder(undefined);
        }, 250);
    }, []);
    const closeMenuAndDo = (callback) => (argument) => {
        handleMenuClose(argument.event);
        callback(contextMenuOrder);
    };
    const showDetails = useCallback(() => {
        history.push(`${history.location.pathname}/${order.id}`);
    }, [history, order]);
    const remove = useCallback((o) => {
        handlers.removeOrder(o.id);
    }, [handlers]);
    const approve = useCallback((o) => {
        handlers.updateOrderApprove(o.id);
    }, [handlers]);
    const cancel = useCallback((o) => {
        handlers.updateOrderCancel(o.id);
    }, [handlers]);
    const complete = useCallback((o) => {
        handlers.updateOrderComplete(o.id);
    }, [handlers]);
    const duplicate = useCallback((o) => {
        handlers.duplicateOrder(o.id);
    }, [handlers]);
    const correct = useCallback((o) => {
        handlers.createOrderCorrection(o === null || o === void 0 ? void 0 : o.id);
    }, [handlers]);
    const canApprove = order.sumOfModelQuantities > 0 && order.allModelsReady && order.allComponentVariantsReady;
    return (React.createElement("div", { className: "OrderListingMenu" },
        React.createElement(Link, { to: `${history.location.pathname}/${order.id}` }, order.orderId),
        React.createElement(IconButton, { className: "options-icon", size: "small", onClick: handleMenuOpen(order) },
            React.createElement(Options, null)),
        React.createElement(Menu, { anchorEl: anchorEl, keepMounted: true, open: Boolean(anchorEl), onClose: handleMenuClose },
            React.createElement(ThemedMenuItem, { key: "show_details", onClick: closeMenuAndDo(showDetails), text: t('orders:show_details') }),
            (contextMenuOrder === null || contextMenuOrder === void 0 ? void 0 : contextMenuOrder.status) === 'DRAFT' && [
                React.createElement(ThemedMenuItem, { key: "approve", onClick: closeMenuAndDo(approve), text: t('orders:approve'), disabled: !canApprove }),
                React.createElement(ThemedMenuItem, { key: "remove", onClick: closeMenuAndDo(remove), text: t('orders:remove') }),
            ],
            (contextMenuOrder === null || contextMenuOrder === void 0 ? void 0 : contextMenuOrder.status) === 'APPROVED' && [
                React.createElement(ThemedMenuItem, { key: "cancel", onClick: closeMenuAndDo(cancel), text: t('orders:cancel') }),
                React.createElement(ThemedMenuItem, { key: "complete", onClick: closeMenuAndDo(complete), text: t('orders:complete') }),
                React.createElement(ThemedMenuItem, { key: "correct", onClick: closeMenuAndDo(correct), text: t('orders:correction_action') }),
            ],
            React.createElement(ThemedMenuItem, { key: "duplicate", onClick: closeMenuAndDo(duplicate), text: (contextMenuOrder === null || contextMenuOrder === void 0 ? void 0 : contextMenuOrder.status) === 'DRAFT'
                    ? t('orders:duplicate')
                    : t('orders:duplicate_as_draft') }))));
};
export default memo(OrderListingMenu);
